module.exports = __webpack_public_path__ + "jm.svg?c5279e8583934fd4fcc2b95faab316c9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/jm.svg
// module id = 1177
// module chunks = 0